module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts6.d7ee7eb3.png";